import { render, staticRenderFns } from "./ChoosePositionPopup.vue?vue&type=template&id=5542b8a4&"
import script from "./ChoosePositionPopup.vue?vue&type=script&lang=js&"
export * from "./ChoosePositionPopup.vue?vue&type=script&lang=js&"
import style0 from "./ChoosePositionPopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports